import PropTypes from 'prop-types'
import React from 'react'
import Icon from '../icon/Icon'
import { Grid } from '@mui/material'

const IconCard = ({
    children = undefined,
    children2 = undefined,
    color = 'white',
    className = '',
    icon = '',
    icon2 = '',
    iconColor = 'white',
    iconClassName = '',
    button = '',
    buttonColor = 'white',
    style = {},
    onClick = () => { },
    onClickButton = () => { },
}) => (
    <div className={`${color} ${className || ''}`} style={{ padding: '5px', margin: '2px', borderRadius: '10px', ...style }}>
        <Grid container>
            <Grid size={12}>
                <div onClick={onClick}>
                    {
                        icon ? (
                            <Grid container>
                                <Grid container size={children2 ? 11 : 12} sx={{ alignItems: 'center', padding: 0 }}>
                                    <Grid size={1}>
                                        <Icon
                                            icon={icon}
                                            className={iconClassName}
                                            style={{ color: iconColor }}
                                        />
                                    </Grid>
                                    <Grid size={icon2 ? 10 : 11} className={color !== 'white' ? 'white-text' : ''} sx={{ padding: 0 }}>
                                        {children}
                                    </Grid>
                                    {
                                        icon2 && (
                                            <Grid size={1}>
                                                <Icon
                                                    icon={icon2}
                                                    className={iconClassName}
                                                    style={{ color: iconColor }}
                                                />
                                            </Grid>
                                        )
                                    }
                                </Grid>
                                { children2 && <Grid size={1}>{ children2 }</Grid> }
                            </Grid>
                        ) : children
                    }
                </div>
                {
                    !!button && (
                        <div onClick={onClickButton}>
                            <div className='right'>
                                <Icon icon={button} style={{ color: buttonColor }} />
                            </div>
                        </div>
                    )
                }
            </Grid>
        </Grid>
    </div>
)

IconCard.propTypes = {
    children: PropTypes.element.isRequired,
    children2: PropTypes.element,
    icon: PropTypes.string,
    iconColor: PropTypes.string,
    icon2: PropTypes.string,
    iconClassName: PropTypes.string,
    button: PropTypes.string,
    buttonColor: PropTypes.string,
    onClick: PropTypes.func,
    onClickButton: PropTypes.func,
    color: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
}

export default IconCard
